<div id="training-details" class="page-layout carded fullwidth inner-scroll">

    <div class="center">
        <div class="content-card" style="overflow-y: scroll;">

            <!-- LOADING -->
            <div *ngIf="loading" class="spinner-container" fxLayout="row" fxLayoutAlign="center center" style="padding: 48px;">
                <mat-spinner [diameter]="60"></mat-spinner>
            </div>

            <!-- TRAINING DETAILS -->
            <div *ngIf="!loading && training">

                <!-- HEADER -->
                <div class="header accent p-24" fxLayout="column" fxLayoutAlign="space-between">
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <div>
                            <h1 style="margin: 0;">{{'Training Session'|translate}}</h1>
                            <h3 style="margin: 8px 0 0 0; color: rgba(255,255,255,0.7);">
<!--                                {{training.timestamps?.startedAt | date: 'd MMMM y, H:mm':'UTC': 'pl'}}-->
                            </h3>
                        </div>
                        <div fxLayout="column" fxLayoutAlign="start end" fxLayoutGap="8px">
                            <span *ngIf="training.isActive && (!training.timeLeft || training.timeLeft > 0)" style="background: #4CAF50; color: white; padding: 8px 16px; border-radius: 4px; font-weight: 500;">
                                {{'Active'|translate}}
                            </span>
                            <span *ngIf="!training.isActive || (training.timeLeft !== undefined && training.timeLeft <= 0)" style="background: #757575; color: white; padding: 8px 16px; border-radius: 4px; font-weight: 500;">
                                {{'Finished'|translate}}
                            </span>
                            <div *ngIf="training.timeLeft && training.timeLeft > 0" style="background: rgba(255,255,255,0.2); color: white; padding: 8px 16px; border-radius: 4px; font-weight: 500;" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="8px">
                                <mat-icon style="font-size: 20px; width: 20px; height: 20px;">timer</mat-icon>
                                <span>{{formatTimeLeft(training.timeLeft)}}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- SUMMARY CARDS -->
                <div class="p-24" fxLayout="row wrap" fxLayoutGap="16px">

                    <!-- Device Image Card -->
                    <div fxFlex="100" fxFlex.gt-sm="48" fxFlex.gt-md="32" class="mat-card mat-elevation-z2 p-16">
                        <h3 class="m-0 mb-16">{{'Device'|translate}}</h3>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
                            <!-- Device Image/Icon -->
                            <div fxFlex="none">
                                <div *ngIf="training.resource?.image">
                                    <img [src]="training.resource.image" [alt]="training.resource.name" style="width: 80px; height: 80px; object-fit: cover; border-radius: 8px;"/>
                                </div>
                                <div *ngIf="!training.resource?.image" style="padding: 12px; background: rgba(0,0,0,0.05); border-radius: 8px;">
                                    <mat-icon style="font-size: 56px; width: 56px; height: 56px; color: rgba(0,0,0,0.3);">fitness_center</mat-icon>
                                </div>
                            </div>
                            <!-- Device Info -->
                            <div fxFlex fxLayout="column">
                                <div class="mb-8" *ngIf="training.resource">
                                    <strong>{{training.resource.name}}</strong>
                                </div>
                                <div *ngIf="!training.resource && training.deviceType" class="mb-8">
                                    <strong>{{training.deviceType}}</strong>
                                </div>
                                <div class="mb-4" style="color: rgba(0,0,0,0.6);">
                                    {{'Type'|translate}}: {{training.deviceType || '-'}}
                                </div>
                                <div style="color: rgba(0,0,0,0.6);">
                                    {{'Serial Number'|translate}}: {{training.deviceSerialNumber || '-'}}
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- User Info Card -->
                    <div fxFlex="100" fxFlex.gt-sm="48" fxFlex.gt-md="32" class="mat-card mat-elevation-z2 p-16">
                        <h3 class="m-0 mb-16">{{'Customer'|translate}}</h3>
                        <div *ngIf="training.user" fxLayout="column">
                            <div class="mb-8">
                                <strong>{{training.user.firstName}} {{training.user.lastName}}</strong>
                            </div>
                            <div *ngIf="training.user.email" class="mb-4" style="color: rgba(0,0,0,0.6);">
                                <mat-icon style="font-size: 16px; width: 16px; height: 16px; line-height: 16px;">email</mat-icon>
                                {{training.user.email}}
                            </div>
                            <div *ngIf="training.user.phone" style="color: rgba(0,0,0,0.6);">
                                <mat-icon style="font-size: 16px; width: 16px; height: 16px; line-height: 16px;">phone</mat-icon>
                                {{training.user.phone}}
                            </div>
                        </div>
                        <div *ngIf="!training.user" style="color: rgba(0,0,0,0.6);">
                            {{'No customer information'|translate}}
                        </div>
                    </div>

                    <!-- Duration Card -->
                    <div fxFlex="100" fxFlex.gt-sm="48" fxFlex.gt-md="32" class="mat-card mat-elevation-z2 p-16">
                        <h3 class="m-0 mb-16">{{'Duration'|translate}}</h3>
                        <div fxLayout="column">
                            <div class="mb-8" style="font-size: 32px; font-weight: 500; color: #3F51B5;">
                                {{formatDuration(training.timestamps?.duration)}}
                            </div>
                            <div class="mb-4" style="color: rgba(0,0,0,0.6);">
                                {{'Started'|translate}}: {{training.timestamps?.startedAt | date: 'H:mm'}}
                            </div>
                            <div *ngIf="training.timestamps?.finishedAt" style="color: rgba(0,0,0,0.6);">
                                {{'Finished'|translate}}: {{training.timestamps?.finishedAt | date: 'H:mm'}}
                            </div>
                        </div>
                    </div>

                </div>

                <!-- METRICS CARDS -->
                <div class="p-24 pt-0" fxLayout="row wrap" fxLayoutGap="16px">

                    <!-- Distance -->
                    <div fxFlex="100" fxFlex.gt-xs="48" fxFlex.gt-sm="32" class="mat-card mat-elevation-z2 p-16" style="text-align: center;">
                        <div fxLayout="column" fxLayoutAlign="center center">
                            <mat-icon style="font-size: 48px; width: 48px; height: 48px; color: #FF9800; margin-bottom: 8px;">directions_run</mat-icon>
                            <h2 style="margin: 8px 0; font-size: 28px; font-weight: 500;">
                                {{training.metrics?.totalDistance ? (training.metrics.totalDistance / 100000 | number:'1.2-2') : '0'}}
                            </h2>
                            <div style="color: rgba(0,0,0,0.6);">{{'Distance'|translate}} (km)</div>
                        </div>
                    </div>

                    <!-- Calories -->
                    <div fxFlex="100" fxFlex.gt-xs="48" fxFlex.gt-sm="32" class="mat-card mat-elevation-z2 p-16" style="text-align: center;">
                        <div fxLayout="column" fxLayoutAlign="center center">
                            <mat-icon style="font-size: 48px; width: 48px; height: 48px; color: #F44336; margin-bottom: 8px;">whatshot</mat-icon>
                            <h2 style="margin: 8px 0; font-size: 28px; font-weight: 500;">
                                {{training.metrics?.totalCalories ? (training.metrics.totalCalories | number:'1.0-0') : '0'}}
                            </h2>
                            <div style="color: rgba(0,0,0,0.6);">{{'Calories'|translate}}</div>
                        </div>
                    </div>

                    <!-- Avg Speed -->
                    <div fxFlex="100" fxFlex.gt-xs="48" fxFlex.gt-sm="32" class="mat-card mat-elevation-z2 p-16" style="text-align: center;">
                        <div fxLayout="column" fxLayoutAlign="center center">
                            <mat-icon style="font-size: 48px; width: 48px; height: 48px; color: #2196F3; margin-bottom: 8px;">dashboard</mat-icon>
                            <h2 style="margin: 8px 0; font-size: 28px; font-weight: 500;">
                                {{training.metrics?.avgSpeed ? ((training.metrics.avgSpeed/10) | number:'1.1-1') : '0'}}
                            </h2>
                            <div style="color: rgba(0,0,0,0.6);">{{'Avg Speed'|translate}} (km/h)</div>
                        </div>
                    </div>

                </div>

                <!-- PERFORMANCE CHARTS -->
                <div class="p-24 pt-0" *ngIf="trainingLogs && trainingLogs.length > 0">
                    <div class="mat-card mat-elevation-z2 p-24">
                        <h2 class="m-0 mb-24">{{'Performance Charts'|translate}}</h2>

                        <!-- Speed Chart -->
                        <div class="mb-24" *ngIf="speedChartData && speedChartData.datasets[0].data.length > 0">
                            <h3>{{'Speed Over Time'|translate}}</h3>
                            <div style="height: 300px;">
                                <canvas baseChart
                                        [datasets]="speedChartData.datasets"
                                        [labels]="speedChartData.labels"
                                        [options]="lineChartOptions"
                                        [colors]="speedChartColors"
                                        [legend]="true"
                                        [chartType]="'line'">
                                </canvas>
                            </div>
                        </div>

                        <!-- Heart Rate Chart -->
                        <div class="mb-24" *ngIf="heartRateChartData && heartRateChartData.datasets[0].data.length > 0">
                            <h3>{{'Heart Rate Over Time'|translate}}</h3>
                            <div style="height: 300px;">
                                <canvas baseChart
                                        [datasets]="heartRateChartData.datasets"
                                        [labels]="heartRateChartData.labels"
                                        [options]="lineChartOptions"
                                        [colors]="heartRateChartColors"
                                        [legend]="true"
                                        [chartType]="'line'">
                                </canvas>
                            </div>
                        </div>

                        <!-- Distance and Calories Chart -->
                        <div *ngIf="distanceCaloriesChartData && distanceCaloriesChartData.datasets.length > 0">
                            <h3>{{'Distance & Calories Over Time'|translate}}</h3>
                            <div style="height: 300px;">
                                <canvas baseChart
                                        [datasets]="distanceCaloriesChartData.datasets"
                                        [labels]="distanceCaloriesChartData.labels"
                                        [options]="dualAxisChartOptions"
                                        [colors]="distanceCaloriesChartColors"
                                        [legend]="true"
                                        [chartType]="'line'">
                                </canvas>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- DETAILED STATISTICS TABLE -->
                <div class="p-24 pt-0">
                    <div class="mat-card mat-elevation-z2 p-24">
                        <h2 class="m-0 mb-24">{{'Detailed Statistics'|translate}}</h2>

                        <table class="table" style="width: 100%;">
                            <tbody>
                                <tr>
                                    <td style="padding: 12px; font-weight: 500;">{{'Avg Speed'|translate}}</td>
                                    <td style="padding: 12px; text-align: right;">{{training.metrics?.avgSpeed ? (training.metrics.avgSpeed/10 | number:'1.1-1') + ' km/h' : '-'}}</td>
                                    <td style="padding: 12px; font-weight: 500;">{{'Max Speed'|translate}}</td>
                                    <td style="padding: 12px; text-align: right;">{{training.metrics?.maxSpeed ? (training.metrics.maxSpeed/10 | number:'1.1-1') + ' km/h' : '-'}}</td>
                                </tr>
                                <tr>
                                    <td style="padding: 12px; font-weight: 500;">{{'Avg Heart Rate'|translate}}</td>
                                    <td style="padding: 12px; text-align: right;">{{training.metrics?.avgHeartRate ? (training.metrics.avgHeartRate | number:'1.0-0') + ' bpm' : '-'}}</td>
                                    <td style="padding: 12px; font-weight: 500;">{{'Max Heart Rate'|translate}}</td>
                                    <td style="padding: 12px; text-align: right;">{{training.metrics?.maxHeartRate ? (training.metrics.maxHeartRate | number:'1.0-0') + ' bpm' : '-'}}</td>
                                </tr>
                                <tr style="background: rgba(0,0,0,0.02);">
                                    <td style="padding: 12px; font-weight: 500;">{{'Total Distance'|translate}}</td>
                                    <td style="padding: 12px; text-align: right;">{{training.metrics?.totalDistance ? (training.metrics.totalDistance / 100000 | number:'1.2-2') + ' km' : '-'}}</td>
                                    <td style="padding: 12px; font-weight: 500;">{{'Total Calories'|translate}}</td>
                                    <td style="padding: 12px; text-align: right;">{{training.metrics?.totalCalories ? (training.metrics.totalCalories | number:'1.0-0') : '-'}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- TRAINING LOGS -->
                <div class="p-24 pt-0" *ngIf="trainingLogs && trainingLogs.length > 0">
                    <div class="mat-card mat-elevation-z2 p-24">
                        <h2 class="m-0 mb-24">{{'Training Log Data'|translate}}</h2>

                        <div style="max-height: 400px; overflow-y: auto;">
                            <table class="table table-hover" style="width: 100%;">
                                <thead style="position: sticky; top: 0; background: white; z-index: 1;">
                                    <tr>
                                        <th style="padding: 12px;">#</th>
                                        <th style="padding: 12px;">{{'Timestamp'|translate}}</th>
                                        <th style="padding: 12px; text-align: right;">{{'Speed'|translate}} (km/h)</th>
                                        <th style="padding: 12px; text-align: right;">{{'Distance'|translate}} (m)</th>
                                        <th style="padding: 12px; text-align: right;">{{'Calories'|translate}}</th>
                                        <th style="padding: 12px; text-align: right;">{{'Heart Rate'|translate}} (bpm)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let log of trainingLogs; let i = index">
                                        <td style="padding: 12px;">{{i + 1}}</td>
                                        <td style="padding: 12px;">{{log.timestamp | date: 'H:mm:ss':'UTC': 'pl'}}</td>
                                        <td style="padding: 12px; text-align: right;">{{log.data.speed/10 || '-'}}</td>
                                        <td style="padding: 12px; text-align: right;">{{log.data.distance/100 || '-'}}</td>
                                        <td style="padding: 12px; text-align: right;">{{log.data.calories || '-'}}</td>
                                        <td style="padding: 12px; text-align: right;">{{log.data.pulse || '-'}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </div>

</div>